import { type DossierWrite, undoAction } from "../dossierWrites";
import { orderActions, withOrders } from "../orderSync";
import { usePropagation, worthShowing } from "./propagation";

/** Avis récapitulatif d'une écriture qui a propagé des missions ou relu des rôles (docs/25 §6) ; faux s'il n'y a
 *  rien à dire (l'avis ordinaire s'affiche alors). `recorded` : l'écriture est dans l'historique (« Annuler tout ») ;
 *  `detail` : notes propres à l'action, complétées des ordres recomposés. */
export function showPropagation(write: DossierWrite, recorded: boolean, detail?: string): boolean {
  const { result } = write;
  if (!worthShowing(result.propagation)) return false;
  const undo = undoAction(recorded);
  usePropagation.getState().show({
    propagation: result.propagation,
    undo: undo?.run,
    order: orderActions(undefined, result).action,
    detail: withOrders(detail, result),
  });
  return true;
}
